import { useEffect, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppReadyState, useAuthChangeEffect, useHydrateEffect } from '@/containers/AppReadyState';
import { useFetchApp, useInitSentry } from '@/containers/AppStateEffect/hooks';
import { useValidSessionChecker } from './hooks/useValidSessionChecker';

type Props = {
  children: React.ReactNode;
};

export const AppStateEffectContainer = (props: Props) => {
  const navigate = useNavigate();
  const app = useAppReadyState();
  const fetchApp = useFetchApp();

  const initSentry = useInitSentry();

  useHydrateEffect(() => {
    initSentry();
  });

  useAuthChangeEffect(auth => {
    if (!auth) {
      navigate('/logout');
    }
  });

  useEffect(() => {
    if (app.authenticated) {
      fetchApp();
    }
  }, [
    app.authenticated,
    fetchApp,
  ]);

  useValidSessionChecker({
    enabled: app.initialized && app.authenticated,
  });

  return (
    <Fragment>
      {props.children}
    </Fragment>
  );
};

AppStateEffectContainer.displayName = 'AppStateEffectContainer';